import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../../services/config';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { HubEndpoint } from '../../constants/hub-endpoint';
import { HubTrucksModel } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class HubTrucksService {
  constructor(private http: WrapperHttpService) {}

  getHubTrucks(hubId: string): Observable<HubTrucksModel> {
    return this.http.withLoading().get<HubTrucksModel>(`${API_URL}${HubEndpoint.Base}/${hubId}${HubEndpoint.Trucks}`);
  }

  updateHubTrucks(hubId: number, data: HubTrucksModel): Observable<HubTrucksModel> {
    return this.http
      .withLoading()
      .post<HubTrucksModel>(`${API_URL}${HubEndpoint.Base}/${hubId}${HubEndpoint.Trucks}`, data);
  }
}
